export enum Brand {
  NG = "NG",
  LM = "LM",
}

export enum Locale {
  at = "en-at" /** Austria */,
  be = "en-be" /** Belgium */,
  cy = "en-cy" /** Cyprus */,
  cz = "en-cz" /** Czechia */,
  dk = "da-dk" /** Denmark */,
  de = "en-de" /** Germany */,
  ee = "en-ee" /** Estonia */,
  es = "en-es" /** Spain */,
  fi = "fi-fi" /** Filand */,
  fr = "en-fr" /** France */,
  gr = "en-gr" /** Greece */,
  hr = "en-hr" /** Croatia */,
  hu = "en-hu" /** Hungary */,
  it = "en-it" /** Italy */,
  lt = "en-lt" /** Lithuania */,
  lv = "en-lv" /** Latvia */,
  nl = "nl-nl" /** Netherlands */,
  no = "nb-no" /** Norway */,
  pl = "en-pl" /** Poland */,
  pt = "en-pt" /** Portugal */,
  ro = "en-ro" /** Romnia */,
  se = "sv-se" /** Sweden */,
  si = "en-si" /** Slovenia */,
  sk = "en-sk" /** Slovakia */,
}

export enum Market {
  at = "at" /** Austria */,
  be = "be" /** Belgium */,
  cy = "cy" /** Cyprus */,
  cz = "cz" /** Czechia */,
  dk = "dk" /** Denmark */,
  de = "de" /** Germany */,
  ee = "ee" /** Estonia */,
  es = "es" /** Spain */,
  fi = "fi" /** Filand */,
  fr = "fr" /** France */,
  gr = "gr" /** Greece */,
  hr = "hr" /** Croatia */,
  hu = "hu" /** Hungary */,
  it = "it" /** Italy */,
  lt = "lt" /** Lithuania */,
  lv = "lv" /** Latvia */,
  nl = "nl" /** Netherlands */,
  no = "no" /** Norway */,
  pl = "pl" /** Poland */,
  pt = "pt" /** Portugal */,
  ro = "ro" /** Romnia */,
  se = "se" /** Sweden */,
  si = "si" /** Slovenia */,
  sk = "sk" /** Slovakia */,
}
